<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        탐지
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Detect</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else class="animated fadeIn" id="detect_detail">
      <b-row>
        <b-col v-if="thumbnail_size == '100%'" lg="7">
          <b-card class="text-center">
            <div slot="header">
              <strong class="float-left">탐지 상세</strong>
              <small class="float-right" v-if="!add && model.detected_at">점검 시작 시간 : ({{model.detected_at | datetime}})</small>
            </div>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <b-button link block variant="light" @click="copy(model.task_key, 'ticket')" id="tooltip-target-1">
                    <h4> 티켓 : {{model.task_key}} </h4>
                  </b-button>
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    FQDN을 눌러 티켓을 복사할 수 있습니다. 사이트에 문제가 있는 경우 티켓으로 문의해야합니다.
                  </b-tooltip>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <!-- <b-col md="2"></b-col> -->
              <b-col>
                <b-row>
                  <b-col>
                      <b-form-group>
                      <label for="ph_username" v-b-tooltip.hover>이름</label><br>
                      <label for="ph_domain">{{model && model.site && model.site.name || 'No current data'}}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col>
                    <b-form-group>
                      <label for="ph_domain" v-b-tooltip.hover>점검 도메인</label><br>
                      <label for="ph_domain">{{model.domain}}</label>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' ? 4 : 3">
                <b-form-group>
                  <label v-b-tooltip.hover title="패턴의 위험 정도를 나타냅니다">
                    레벨
                    <span>
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <br>
                  <b-badge variant="danger" v-if="codes.WMDS_LEVEL[model.level] == 'Danger'"> {{codes.WMDS_LEVEL[model.level]}}</b-badge>
                  <b-badge variant="warning" v-else-if="codes.WMDS_LEVEL[model.level] == 'Warning'"> {{codes.WMDS_LEVEL[model.level]}}</b-badge>
                  <b-badge variant="warning" v-else-if="codes.WMDS_LEVEL[model.level] == 'Caution'"> {{codes.WMDS_LEVEL[model.level]}}</b-badge>
                  <b-badge variant="primary" v-else-if="codes.WMDS_LEVEL[model.level] == 'Suspicious'"> {{codes.WMDS_LEVEL[model.level]}}</b-badge>
                  <b-badge variant="primary" v-else> {{codes.WMDS_LEVEL[model.level]}}</b-badge>
                </b-form-group>
              </b-col>
              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' || codes.WMDS_TYPE[model.type] == 'Regex' ? 4 : 3">
                <label v-b-tooltip.hover title="패턴 유형을 설명합니다">
                  탐지 타입
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && model.type">{{codes.WMDS_TYPE[model.type]}}</p>
              </b-col>
              <b-col :md="model && codes.WMDS_TYPE[model.type] == 'MD5' || codes.WMDS_TYPE[model.type] == 'Regex' ? 4 : 3">
                <label v-b-tooltip.hover title="탐지된 페이지가 통과한 사이트 링크 수를 나타냅니다.">
                  참조 경로
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && model.type">{{depth}}</p>
              </b-col>
              <b-col v-if="model && codes.WMDS_TYPE[model.type] != 'MD5' && codes.WMDS_TYPE[model.type] != 'Regex'" md="3">
                <!-- URL, String -->
                <label v-if="codes.WMDS_TYPE[model.type] == 'URL'" v-b-tooltip.hover title="사이트에서 패턴이 탐지된 라인을 표시합니다. 이 라인은 사이트의 동적 로딩이 완료된 라인 번호입니다.">
                  라인
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && codes.WMDS_TYPE[model.type] == 'URL'">{{row_id + 1 || '-'}}</p>

                <!-- MD5 -->
                <!-- <p v-if="model && codes.WMDS_TYPE[model.type] == 'MD5'">{{row_id + 1 || '-'}}</p> -->

                <!-- Regex -->
                <!-- <label v-if="codes.WMDS_TYPE[model.type] == 'Regex'" v-b-tooltip.hover title="Displays the number matched by a regular expression">
                  매칭 개수
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <p v-if="model && codes.WMDS_TYPE[model.type] == 'Regex'">{{row_count || '-'}}</p> -->
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <table class="table table-sm table-dark">
                  <thead>
                    <tr>
                      <th scope="col">무결성 검증 방법</th>
                      <th scope="col">값</th>
                      <th scope="col">설명</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in ([{ type : 'MD5', value : model.md5, desc : 'Detected page url' }, { type : 'URL HASH', value : model.url_hash, desc : 'Detected page url hash' }] || [])" :key="index">
                      <th scope="row">{{row.type}}</th>
                      <th scope="row">{{row.value}}</th>
                      <th scope="row">{{row.desc ? row.desc : '-'}}</th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <!-- <b-col md="6">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>HASH</label><br>
                  <label for="ph_ext" v-if="model && model.detail_data">{{model.url_hash}}</label>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>MD5</label><br>
                  <label for="ph_ext" v-if="model && model.detail_data">{{model.md5}}</label>
                </b-form-group>
              </b-col> -->
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <h3>
                  <p for="ph_count" v-b-tooltip.hover>탐지 패턴</p>
                  <span v-if="model.data && (model.f1code || model.ucode)">{{model.f1code || model.ucode}}</span>
                </h3>
              </b-col>
            </b-row>
            <hr>
            <b-button size="sm" variant="danger" class="float-left" @click="confirm = true"> 삭제 </b-button>
            <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
          </b-card>
        </b-col>
        <b-col lg="12" :xl="thumbnail_size == '100%' ? 5 : 12">
          <b-card>
            <div slot="header" class="text-center">
              <strong>스크린샷</strong>
            </div>
            <b-row class="text-center">
              <b-col md="12">
                <a @click="toggle_thumbnail" >
                  <img :src="image" style="max-width:850px; cursor:pointer;" :style="{ width: thumbnail_size }">
                </a>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card style="max-height: 400px; overflow: auto;">
            <div slot="header">
              <strong>탐지 경로</strong>
              <label class="float-right" v-if="model">총 {{depth}} 개의 경로</label>
            </div>
            <b-row>
              <b-col md="12">
                <pre slot="body" style="max-width: 100%; max-height: 500px; overflow:auto;">
                  <div v-for="(item, index) in model.url_tree" :key="index" :style="{ 'padding-left' : index * 10 + 'px'}">경로 : {{index+1}} ==> {{item}}
                  </div>
                </pre>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="1" xl="12">
          <b-card>
            <div slot="header">
              <strong>HTML 데이터</strong>
              <b-button class="float-right" size="sm" variant="primary" @click="save_rs"> HTML 소스 다운로드 </b-button>
              <b-button class="float-right mr-2" size="sm" variant="warning" @click="copy(model.data, 'html source code')"> 복사 </b-button>
              <b-button :disabled="codes.WMDS_TYPE[model.type] == 'MD5'" class="btn-add float-right mr-2" size="sm" variant="success" @click="heilith"> 탐지 부분 표시 </b-button>
            </div>
            <b-row>
              <b-col md="12" id>
                <!-- <img src="img/texteditorline.png"> -->
                <!-- <b-form-textarea
                    style="overflow: auto;"
                    id="data"
                    :rows="50"
                    v-model="model.data"
                    @change="selecting"
                  >
                </b-form-textarea> -->

                <div>
                  <!-- <pre id="data" slot="body" style="width: 3000px; overflow: visible;">{{model.data}}</pre> -->
                  <!-- <text-highlight style="width: 3000px; overflow: visible;" :queries="[this.model.f1code || this.model.ucode]">
                    {{ model.data }}
                  </text-highlight> -->
                  <htmlViewer :type="codes.WMDS_TYPE[model.type]" ref="html_viewer" @line="x => row_id = x" :html="model.data" :search="this.model.f1code || this.model.ucode" effect='text-danger' />
                </div>
                <!-- <button onclick="TLN.append_line_numbers('test')"> NUMBERIFY! </button>
                <div id="wrapper">
                    <textarea id="test" class="banana-cake"></textarea>
                </div> -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal title="탐지 데이터 삭제"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
        이 작업은 되돌릴 수 없습니다.
      </b-modal>
    </div>
    <!-- load custom -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
